export default __webpack_public_path__ + "static/media/airbnb.4e5cb5ca.png";